import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Dropdown, DropdownItem, InlineAlert } from '@amzn/storm-ui';
import { FormRow } from '@amzn/storm-ui-column-form-kit';

import { ROLE_ENUM_TO_LABEL_MAP, UserRoles } from '../../Shared/constants/userRoles';
import { useAppContext } from '../../Shared/store/appContext';

const ADMIN_ALLOWED_ROLES = [UserRoles.ACCOUNT_EXECUTIVE, UserRoles.ACCOUNT_MANAGER];

const UserRoleDropDown = ({
  userRole,
  setUserRole,
  error,
}: {
  userRole: string;
  setUserRole: (value: string) => void;
  error?: string;
}) => {
  const { t } = useTranslation();
  const { state } = useAppContext();
  const currentUserRole = state.currentUser?.role;

  const availableRoles = useMemo(() => {
    if (currentUserRole === UserRoles.ADMIN) {
      return ROLE_ENUM_TO_LABEL_MAP.filter(({ role }) => ADMIN_ALLOWED_ROLES.includes(role));
    }
    return ROLE_ENUM_TO_LABEL_MAP;
  }, [currentUserRole]);

  return (
    <FormRow
      id="user-role"
      label={t('user-role-form-label')}
      controlComponents={[
        (componentId) => (
          <>
            <Dropdown
              id={componentId}
              selectedValue={userRole || ''}
              onChange={(value: string) => setUserRole(value)}
              error={!!error}
            >
              {!userRole && (
                <DropdownItem id="dropdown-item-placeholder" value="" disabled>
                  {t('select-user-role')}
                </DropdownItem>
              )}
              {availableRoles.map(({ role, label }) => (
                <DropdownItem
                  id={`dropdown-item-${role}`}
                  key={role}
                  value={role}
                >
                  {t(label)}
                </DropdownItem>
              ))}
            </Dropdown>
            {!!error && <InlineAlert message={error} variant="error" />}
          </>
        ),
      ]}
    />
  );
};

export default UserRoleDropDown;
